import React, { useState } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import styled from 'styled-components';
import { Icon } from '../inputs/icon';

const CopyWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  display: inline;
  cursor: pointer;
  padding: 0 10px;

  i {
    transform: rotate(-45deg);
  }
`;

const Toast = styled.div`
  position: absolute;
  border-radius: 5px;
  background: ${props => props.theme.colors.complimentaryPurple};
  padding: 5px 15px;
  z-index: 10;
  opacity: ${props => (props.isCopied ? 1 : 0)};
  transition: 0.3s all ease;
  right: -23px;
  top: -50px;

  &:after {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: -8px;
    width: 0;
    height: 0;
    border-top: solid 8px ${props => props.theme.colors.complimentaryPurple};
    border-left: solid 8px transparent;
    border-right: solid 8px transparent;
  }
`;

export function CopyLink({ onClick, textToCopy, toastText }) {
  const [isCopied, setIsCopied] = useState(false);

  const handleCopy = () => {
    setIsCopied(true);

    setTimeout(() => {
      setIsCopied(false);
    }, 1400);
  };

  return (
    <CopyToClipboard
      text={textToCopy}
      onCopy={() => handleCopy()}
      onClick={onClick}
    >
      <CopyWrapper>
        <Toast isCopied={isCopied}>{toastText || 'Copied!'}</Toast>
        <Icon name="link" alt="copy button" />
      </CopyWrapper>
    </CopyToClipboard>
  );
}
